import React, { useEffect, useState } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {GetHeaders} from '../../../../../reduxToolkit/headers/HeadersApi';
import {useTranslation} from 'react-i18next';
import {HEADER_DATA} from '../Model/Models';
import {status, STATUS_MODEL} from '../../../../../enums/statusEnum';
import { permissionObj } from '../../../../../Helpers/permission';

const DetailsApp = ({userData}) => {

    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [contractorId, setContractorId] = useState(sessionStorage.getItem('contractorId'));
    const [supplierId, setSupplierId] = useState(sessionStorage.getItem('providerId'));
    const dispatch = useDispatch();
    const [headerObj, setHeaderObj] = useState({...HEADER_DATA});
    const canManagePasswords = (DEV || permission?.includes(permissionObj?.WEB_EMPLOYEE_CAN_MANAGE_PASSWORDS));
    const { idSet } = useSelector((state) => state.CommonsSlice);
    const userId = idSet || sessionStorage.getItem('id');

    useEffect(() => {
        dispatch(GetHeaders())
            .unwrap()
            .then(({ data: { data } }) => {
                setHeaderObj({
                    header1: data?.header1 || 'header_1',
                    header2: data?.header2 || 'header_2',
                    header3: data?.header3 || 'header_3',
                    header5: data?.header4 || 'header_4',
                    header6: data?.header5 || 'header_5',
                    header7: data?.header6 || 'header_6',
                    header8: data?.header7 || 'header_7',
                    header9: data?.header8 || 'header_8',
                    header10: data?.header9 || 'header_9',
                    header11: data?.header10 || 'header_10',
                    header12: data?.header11 || 'header_11',
                    header13: data?.header12 || 'header_12',
                    header14: data?.header13 || 'header_13',
                    header15: data?.header14 || 'header_14',
                    header4: data?.header15 || 'header_15',
                });
            });
    }, []);

    const { t } = useTranslation();
    const userInfoStatusList = useSelector((state) => state?.CompanyEmployeesSlice?.userInfoStatusList);
    let userStatusList = [...userInfoStatusList, ]
    if(parseInt(userData.statusId) === STATUS_MODEL.ACCOUNT_LOCKED){
        userStatusList.push({id: STATUS_MODEL.ACCOUNT_LOCKED, name: status[STATUS_MODEL.ACCOUNT_LOCKED]})
    }

    return {
        t,
        userInfoStatusList: userStatusList,
        DEV,
        permission,
        contractorId,
        supplierId,
        canManagePasswords,
        userId,
    }

}



export default DetailsApp;
